import { render, staticRenderFns } from "./clickSelectItems.vue?vue&type=template&id=6b12f994&"
import script from "./clickSelectItems.vue?vue&type=script&lang=js&"
export * from "./clickSelectItems.vue?vue&type=script&lang=js&"
import style0 from "./clickSelectItems.vue?vue&type=style&index=0&id=6b12f994&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports